<template>
    <div class="deck-card-regular" @click.self="viewCards()">
        <div class="deck-card-regular__image" @click="viewCards()">
            <img class="img-fluid" :src="cardDeck.central_image"/>
            <partner-badge v-if="cardDeck.corporateBrand" :floating="true"></partner-badge>
        </div>
        <div v-if="cardDeck.corporateBrand && cardDeck.corporateBrand.logo" class="deck-card-partner__logo-card mt-1">
            <img height="40" :src="cardDeck.corporateBrand.logo">
        </div>
        <div v-else class="d-flex flex-row w-100 align-items-center justify-content-between gap-2" style="margin-top: 24px;">
            <span class="deck-card-regular__date">Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}} • {{ cardDeck.owner ? cardDeck.owner.name : '' }}</span>
        </div>
        <div class="flex-1 w-100" @click="viewCards">
            <div
                class="deck-card-regular__title mt-2 text-truncate">
                {{ cardDeck.title }}
            </div>
            <div class="d-flex flex-row w-100 justify-content-between mt-2">
                <div class="d-flex gap-1">
                    <span class="deck-card-regular__category-label">{{ cardDeck.category.label }}</span>
                    <span class="deck-card-regular__category-label cards-counter">
                        {{ cardDeck.cards.length }} {{ cardDeck.cards.length === 1 ? 'card' : 'cards'}}
                    </span>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column justify-content-end w-100 mt-2">
            <div class="d-flex flex-row gap-1">
                <btn class="btn-primary flex-1" :loading="loading.remove" @click="removeFromMagnusCards">
                    <inline-svg class="me-1" src="/assets/img/icons/phone-02.svg"></inline-svg>
                    Unassign from Hero
                </btn>
            </div>
        </div>
    </div>
</template>

<script>

import MenuDropdown from "@/components/theme/MenuDropdown.vue";
import MenuItem from "@/components/theme/MenuItem.vue";
import AvatarGroup from "@/components/AvatarGroup.vue";
import PartnerBadge from "@/components/PartnerBadge.vue";

export default {
    name: 'DeckCardHero',
    props: ['hideButtons', 'communityCard', 'cardDeck', 'heroName'],
    components: {PartnerBadge, AvatarGroup, MenuItem, MenuDropdown},
    data() {
        return {
            loading: {
                remove: false,
            }
        }
    },
    methods: {
        viewCards() {
            if (this.communityCard) {
                this.$router.push({name: 'card.deck.cards'})
            } else {
                this.$emit('onViewCards', this.cardDeck)
            }
        },
        removeFromMagnusCards() {
            const self = this;
            this.$dialog.confirm('Are you sure you want to unassign this Card Deck from ' + this.heroName + '?', {
                okText: 'Yes',
                cancelText: 'No'
            })
                .then(() => {
                    self.loading.remove = true;
                    self.$http.post('/deck/remove-assigned-hero', { deck_id: this.cardDeck.id, hero_id: this.$route.params.hero_id })
                        .then(function (res) {
                            self.$events.emit('loadHeroCardDecks');
                            self.loading.remove = false;
                        }).catch(() => {
                        self.loading.remove = false;
                    });
                });
        }
    }
};

</script>
